import { FileCommand } from 'app/projects/core/src/lib/models/file.command';

export class UploadFileCommand extends FileCommand {
    constructor(node: string, file: File) {
        super('file', file);

        this.formData.append('node', node);
    }
}
